module.exports = __webpack_public_path__ + "img/image1.2456c44e.png";